<div class="compact-address-container">
  <div class="title">
    <div class="row">
      <!-- title -->
      <div class="col-lg-6">
        <h5>{{ "modeso_address_compact-address_address" | injectedText | async }}</h5>
      </div>
      <!-- button to change address -->
      <div class="col-lg-6" *ngIf="ChangeAddress">
        <ng-content></ng-content>
      </div>
    </div>
    <div *ngIf="!ChangeAddress">
      <hr>
    </div>
  </div>
  <!-- address details -->
  <modeso-compact-address-details id="compactDeliveryAddress" *ngIf="isSetDeliveryAddressId"
    [address]="deliveryAddress$" [addressType]="'modeso_address_compact-address_delivery-address'"
    [isBillingAddress]="isSetBillingAddressId">
  </modeso-compact-address-details>
  <modeso-compact-address-details id="compactBillingAddress" *ngIf="isSetBillingAddressId" [address]="billingAddress$"
    [addressType]="'modeso_address_compact-address_billing-address'" [isBillingAddress]="isSetBillingAddressId">
  </modeso-compact-address-details>
  <div *ngIf="!isSetBillingAddressId" class="address-type">
    <span>{{ "modeso_address_address_delivery-billing" | injectedText | async }}
      {{ "modeso_address_address_same-address" | injectedText | async }}</span>
  </div>
</div>
